export type RobotsOptionsType = {
  /**
   * não mostrar a página, mídia ou recurso nos resultados da pesquisa
   */
  noindex?: { enabled: boolean; };
  /**
   * não seguir os links da página para descobrir novos conteúdos
   */
  nofollow?: { enabled: boolean; };
  /**
   * equivale a noindex e nofollow juntos
   */
  none?: { enabled: boolean; };
  /**
   * não guardar o cache da página nem exibi-lo nos resultados da pesquisa
   */
  noarchive?: { enabled: boolean; };
  /**
   * não exibir o box de busca do site nos resultados da pesquisa
   */
  nositelinkssearchbox?: { enabled: boolean; };
  /**
   * não exibir um snippet de texto ou vídeo nos resultados da pesquisa
   */
  nosnippet?: { enabled: boolean; };
  /**
   * não oferecer a tradução da página nos resultados da pesquisa
   */
  notranslate?: { enabled: boolean; };
  /**
   * não mostrar as imagens da página nos resultados da pesquisa
   */
  noimageindex?: { enabled: boolean; };
  /**
   * [date/time]: não exibir a página nos resultados da pesquisa a partir da data/hora especificada [E, d MMM yyyy HH:mm:ss Z]
   */
  unavailable_after?: { enabled: boolean; date: string };
}

export type UseRobotsProps = {
  enabled: boolean;
  robotsOptions?: RobotsOptionsType;
}

export function useRobots({ enabled, robotsOptions }: UseRobotsProps) {
  if (!enabled) {
    return <></>
  }

  const opts: Array<string> = []

  if (robotsOptions?.noarchive) {
    opts.push('noarchive')
  }
  if (robotsOptions?.nofollow) {
    opts.push('nofollow')
  }
  if (robotsOptions?.noimageindex) {
    opts.push('noimageindex')
  }
  if (robotsOptions?.noindex) {
    opts.push('noindex')
  }
  if (robotsOptions?.nositelinkssearchbox) {
    opts.push('nositelinkssearchbox')
  }
  if (robotsOptions?.nosnippet) {
    opts.push('nosnippet')
  }
  if (robotsOptions?.notranslate) {
    opts.push('notranslate')
  }
  if (robotsOptions?.unavailable_after) {
    opts.push(`unavailable_after: ${robotsOptions?.unavailable_after?.date}`)
  }

  return (
    <>
      {opts.length > 0 && <meta key='robots' name='robots' content={opts.join(', ')} />}
    </>
  )
}